<script>
export default {
  data: () => ({
    designer: false
  }),
  mounted () {
    this.startDesigner()
  },
  methods: {
    startDesigner () {
      this.designer = new window.Stimulsoft.Designer.StiDesigner(null, 'StiViewer', false)
      this.designer.renderHtml('relatorio-designer')
      this.designer.onExit = () => this.$emit('exit')
      this.designer.onSaveAsReport = this.save
      this.designer.onSaveReport = this.save
    },
    setReport (layout) {
      let report = new window.Stimulsoft.Report.StiReport()
      report.load(layout)
      this.designer.report = report
    },
    newReport () {
      let report = new window.Stimulsoft.Report.StiReport()
      this.designer.report = report
    },
    save (dados) {
      if (dados.report) this.$emit('save', dados.report.saveToJsonInternal())
    }
  }
}
</script>

<template>
  <div id="relatorio-designer" />
</template>

<style>
  table td, table th {
    vertical-align: middle;
  }
</style>
